import { makeStyles } from "tss-react/mui";

export const GlobalTableStyles = makeStyles()({

    tableStyle: {
        borderTop: "1px solid #f0f0f0",
        borderLeft: "1px solid #f0f0f0",
        margin: "auto",
        width: "100%",
        borderCollapse: "collapse"
    },
    tableHeader: {
        borderInlineEnd: "1px solid #f0f0f0",
        borderBottom: "1px solid #f0f0f0",
        background: "#fafafa",
        padding: "8px",
        textAlign: "left",
        fontSize: "13px"
    },
    recordingLinkTableHeader: {
        borderBottom: "1px solid #f0f0f0",
        background: "#fafafa",
        padding: "15px 8px",
        textAlign: "left",
        fontSize: "13px"
    },
    tableCell: {
        borderInlineEnd: "1px solid #f0f0f0",
        borderBottom: "1px solid #f0f0f0",
        padding: "8px",
        textAlign: "left",
        fontSize: "14px"
    },
    recordingLinkTableCell: {
        borderBottom: "1px solid #f0f0f0",
        padding: "8px",
        textAlign: "left",
        fontSize: "14px"
    },
    lastCell: {
        borderInlineEnd: "1px solid #f0f0f0",
    },
    tableCellTable: {
        borderInlineEnd: "1px solid #f0f0f0",
        borderBottom: "1px solid #f0f0f0",
        textAlign: "center"
    },
    descriptionStyle: {
        fontSize: "14px",
        marginBottom: "5px",
        'a': {
            fontSize: "13px",
            textDecoration: "none"
        },
    },
    answerListMenu: {
        minWidth: "120px"
    },
    linkStyle: {
        color: "#3B78CE",
        textDecoration: "none",
        display: "flex",
        alignItems: "cneter",
    },
    openIconStyle: {
        width: "16px",
        height: "16px",
        marginLeft: "3px"
    }
})